import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  closeButtonSize: 'md'
} satisfies RecursivePartial<DialogConfig['productDetailCard']>
